<template>
  <div class="location-data">
    <v-icon size="22px" color="primary">
      icon-owner
    </v-icon>
    <div class="location-data__content">
      <div class="location-data__title">
        {{ name }}
      </div>
      <div class="location-data__subtitle">
        {{ address }} | {{ $t("message.common.storeCode") }}:
        {{ storeCode }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "StoreLocatorCompanyCard",
  props: {
    name: {
      type: String,
      required: true
    },
    address: {
      type: String,
      required: true
    },
    storeCode: {
      type: String,
      required: true
    }
  }
};
</script>

<style lang="scss" scoped>
.location-data {
  display: flex;
  align-items: center;
  gap: $spacing * 1.5;
  color: $grey-darker;

  &__title {
    @include font-size(14px);
    font-weight: 500;
    line-height: 22px;
  }

  &__subtitle {
    @include font-size(12px);
    font-weight: 400;
    line-height: 18px;
  }
}
</style>
